import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const PassageLabelsXRayService = {
    apply: async (payload) => axios.post(`${API_URL}/passage-labels-x-ray/apply`, payload).then(({data}) => data.data).catch((err) => { throw err })
};

export default PassageLabelsXRayService;